var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('l-geo-json',{ref:"historicalNodes",attrs:{"pane":"overlayPane","geojson":_vm.geoData,"options":{
      pointToLayer: _vm.createCircles,
    }},on:{"click":function($event){return _vm.gaugeClickGeoJson($event.layer, $event.layer.feature.properties)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }